<template>
  <v-container>
    <v-layout>
      <v-flex v-if="!dialog">
        <v-tooltip top >
          <v-btn
                  class="mr-2 mb-2"
                  @click="newGuiaProessat"
                  color="customPurple"
                  dark
                  fixed
                  bottom
                  right
                  fab
                  slot="activator"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear Guia Proessat</span>
        </v-tooltip>
        <div>
          <v-layout>
            <v-flex xs12 sm6 offset-sm6>
              <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <div v-if="dialog">
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Guia Proessat</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs12 sm4 offset-sm1>
                <v-text-field
                        name="area"
                        label="Área"
                        id="area"
                        :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                        required
                        v-model="guiaProessat.area"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 sm4 offset-sm1>
                <v-text-field
                        name="descripcion"
                        label="Descripción"
                        id="description"
                        :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                        required
                        v-model="guiaProessat.description"
                ></v-text-field>
              </v-flex>
            </v-layout>
          <guia-proessat-data :guia-proessat="this.guiaProessat" :answers-data="this.guiaProessatAnswers" @clickedSomething="handleClickInParent"></guia-proessat-data>
          </v-form>
        </v-card>
      </div>
    </v-layout>
    <h3 class="primary--text" v-if="!dialog">Guías Proessat</h3>
    <v-data-table
            v-if="!dialog"
            :headers="headers"
            :items="$store.state.guiasProessat"
            class="elevation-1"
            sort-icon="mdi-menu-down"
            :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.area }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.date!=null?getDate(props.item.date):''}}</td>
        <td>
          <v-tooltip top >
            <v-btn
                    fab dark
                    small @click="editItem(props.item)"
                    slot="activator"
                    color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top >
            <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
              <v-icon dark>delete</v-icon>
            </v-btn>
            <span>Eliminar</span>
          </v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        No se han encontrado resultados para "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-container>
</template>
<script>
  import GuiaProessat from "../../../model/GuiaProessat";
  import GuiaProessatData from "./GuiaProessatData";

  export default {
    props: ['company'],
    components: {
      GuiaProessatData
    },
    data() {
      return {
        search: '',
        valid: false,
        requiredField: [v => !!v || 'Es requerido'],
        dialog: false,
        headers: [
          { text: 'Area', value: 'area' },
          { text: 'Descripción', value: 'description' },
          { text: 'Fecha', value: 'fecha' },
          { text: 'Acciones', value: 'action' }
        ],
        editedIndex: -1,
        guiaProessat: new GuiaProessat(),
        guiaProessatAnswers:[]
      };
    },
    methods: {
      handleClickInParent: function() {
        this.dialog = false;
        this.guiaProessatAnswers = []
      },
      cleanData() {
        this.$refs.form.reset();
        this.guiaProessat = new GuiaProessat();
        this.valid = false;
        this.dialog = false;
        this.guiaProessatAnswers = []
      },
      newGuiaProessat() {
        this.editedIndex = -1;
        this.valid = false;
        this.dialog = true;
        this.$refs.form.reset();
        this.guiaProessat = new GuiaProessat();
        this.guiaProessat.company = this.company
      },
      getDate(date){
        let d = new Date(date);
        let year = d.getFullYear();
        let month = d.getMonth()+1;
        let day = d.getDate();

        if (day < 10) {
          day = '0' + day;
        }
        if (month < 10) {
          month = '0' + month;
        }

        let formattedDate = day + '-' + month + '-' + year
        return formattedDate

      },
      saveData() {
        if (this.$refs.form.validate()) {
          if (this.editedIndex > -1) {
            this.$store.dispatch('updateGuiaProessat', this.guiaProessat).then(
                    response => {
                      this.cleanData();
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
            );
          } else {
            this.$store.dispatch('addGuiaProessat', this.guiaProessat).then(
                    response => {
                      this.cleanData();
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
            );
          }
          this.dialog = false;
        }
      },
      editItem(item) {
        this.editedIndex = this.$store.state.guiasProessat.indexOf(item);
        this.guiaProessat = Object.assign({}, item);
        this.guiaProessat.company = this.company
        this.$store.dispatch('getGuiasProessatDataByGuiaProessat',this.guiaProessat.id).then(response => {
          this.guiaProessatAnswers=[]
          for(let i=0; i<this.$store.state.guiasProessatData.length;i++){
            this.guiaProessatAnswers.push(this.$store.state.guiasProessatData[i].answer)
          }
          this.dialog = true;
        }, error => {
          this.$store.state.progress = false
          this.$store.state.dialogError = true
        })

      },
      deleteItem(item) {
        this.editedIndex = this.$store.state.guiasProessat.indexOf(item);
        this.guiaProessat = Object.assign({}, item);
        confirm('Está seguro de que quiere eliminar el registro?') &&
        this.$store.dispatch('deleteGuiasProessat', this.guiaProessat.id).then(
                response => {
                  this.$store.dispatch('getGuiasProessatByCompany',this.$store.state.company.id)
                },
                error => {
                  this.$store.state.dialogError = true;
                }
        );
      }
    },
    computed: {}
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/company/guiaProessat/GuiaProessat.vue